import { useMemo } from 'react';

import { useLoggingQuery } from 'lib/apollo/apollo-hooks';
import { studentAuthApolloContextOption } from 'approot/student-class-to-do/student-class-to-do.utils';
import { GET_CLASS_SETTINGS } from 'approot/classes/class-settings.graphql';
import {
  GetClassSettings,
  GetClassSettingsVariables,
} from 'approot/classes/__generated__/GetClassSettings';
import { getStudentClassToDoClassId } from 'approot/students/logic/get-student-class-to-do-class-id';
import { useGetInteractiveLessonParams } from '../activity-builder.hooks';
import useUserData from 'approot/shared/user/user-data';

export const useTeacherOrStudentClassSettings = () => {
  const { userClassId } = useGetInteractiveLessonParams();
  const { isStudentSignedIn } = useUserData();

  const classId = useMemo(
    () =>
      isStudentSignedIn
        ? getStudentClassToDoClassId()
        : userClassId
        ? Number(userClassId)
        : null,
    [isStudentSignedIn, userClassId]
  );

  const { data, loading } = useLoggingQuery<
    GetClassSettings,
    GetClassSettingsVariables
  >(
    GET_CLASS_SETTINGS,
    {
      ...(isStudentSignedIn
        ? { context: studentAuthApolloContextOption() }
        : {}),
      skip: !classId,
      fetchPolicy: 'cache-only',
      variables: {
        input: {
          classId: classId!,
        },
      },
    },
    !isStudentSignedIn
  );

  const settings = data?.getClassSettings;

  const backgroundVisibility =
    !settings || settings.backgroundVisibility === null
      ? true
      : settings.backgroundVisibility;
  const animationAutoPlay =
    !settings || settings.animationAutoPlay === null
      ? true
      : settings.animationAutoPlay;
  const translationEnabled = !!settings?.translationEnabled;
  const translationEnabledStudent = !!settings?.translationEnabledStudent;
  const ttsEnabled = !!settings?.ttsEnabled;
  return {
    data,
    loading,
    backgroundVisibility,
    animationAutoPlay,
    translationEnabled,
    translationEnabledStudent,
    ttsEnabled,
  };
};
